import { mutations } from './mutations';
import { getters } from './getters';
import { actions } from './actions';
import { MainState } from './state';

const defaultState: MainState = {
  isLoggedIn: null,
  token: '',
  logInError: false,
  userProfile: null,
  userCompany: null,
  dashboardMiniDrawer: false,
  dashboardShowDrawer: false,
  designMode: false,
  notifications: [],
  isSetupCompleted: null,
};

export const mainModule = {
  state: defaultState,
  mutations,
  actions,
  getters,
};

export interface Author {
  name: string;
  thumbnailUrl: string;
}

export interface IWPColumn {
  title: string;
  linkUrl: string;
  thumbnailUrl: string;
  date: string;
  author: Author;
}
